import { render } from "./PickupRequestsPage.vue?vue&type=template&id=5af46caa&ts=true"
import script from "./PickupRequestsPage.vue?vue&type=script&lang=ts"
export * from "./PickupRequestsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__